import React, { Component } from 'react'
import { Input, Form, Modal } from 'antd'

const FormItem = Form.Item

class CloneLeadForm extends Component {
  handleCloneLeadLocal = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleCloneLead(values.leadName)
      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, handleToggleCloneLeadForm } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Clone Lead"
        okText={'Clone'}
        onCancel={handleToggleCloneLeadForm}
        onOk={this.handleCloneLeadLocal}
        maskClosable={false}
      >
        <Form layout="vertical">
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Lead Name">
                {getFieldDecorator('leadName', {
                  rules: [
                    {
                      required: true,
                      message: 'Lead name cannot be blank.'
                    }
                  ]
                })(<Input placeholder="Enter the lead name..." />)}
              </FormItem>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(CloneLeadForm)



// WEBPACK FOOTER //
// ./src/components/leads/CloneLeadForm.js